import { cn } from '@repo/ui/utils';

/**
 *
 */
export const PayleoLogo = ({
  width = 100,
  height,
  className,
}: ({ width?: number; height?: number } | { width?: number; height: number }) & {
  className?: string;
}) => (
  <div
    className={cn('inline-block flex-row items-center justify-center gap-1', className, {
      // ["blur-sm"]: env.VITE_APP_ENV === "development",
    })}
  >
    <img src={'/assets/svg/payleo-logo.svg'} width={width} height={height} alt="payleo-logo" />
  </div>
);

export const PayleoMark = ({ size = 10, className }: { size: number; className?: string }) => {
  return (
    <div className={cn('inline-block', className)}>
      <img
        src={'/assets/svg/payleo-mark.svg'}
        width={size * 4.5}
        height={size * 4.5}
        alt="payleo-mark"
      />
    </div>
  );
};
